import { render, staticRenderFns } from "./ListAllWfaOrWfhOrFwa.vue?vue&type=template&id=2a45ae99"
import script from "./ListAllWfaOrWfhOrFwa.vue?vue&type=script&lang=js"
export * from "./ListAllWfaOrWfhOrFwa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports